import React, { useEffect, useRef, useState } from "react";
import QRCode from "react-qr-code";
import {
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Modal,
  ModalBody,
  UncontrolledDropdown
} from "reactstrap";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Button,
  Col,
  Icon,
  Row,
  RSelect,
} from "../../components/Component";
import Content from "../../layout/content/Content";
import Head from "../../layout/head/Head";

import { ErrorMessage } from "@hookform/error-message";
import * as moment from "moment";
import { Controller, FormProvider, useForm } from "react-hook-form";
import { NumericFormat } from "react-number-format";
import ReactSelect from "react-select";
import { toast } from "react-toastify";
import DatePicker from "../../components/range-date-picker/RangeDatePicker";
import Table from "../../components/react-table/Table";
import { DELETE, GET, POST, PUT } from "../../helper/api";
import { ACTION_SCAN, PIECE_WAGE_PRICE_TYPE } from "../../utils/Utils";

import { Buffer } from "buffer";
import { useLocation } from 'react-router-dom';
import { Link, useHistory } from "react-router-dom/cjs/react-router-dom.min";
import SearchBill from "./components/SearchBill";

const DEFAULT_PIECE_WAGE = {
  id: "",
  date: moment().format("YYYY-MM-DD"),
  employee: [],
  leaderShift: [],
  categoryId: '',
  customerId: '',
  amount: 0,
  price: 0,
  priceType: 'STATIC',
  weight: 1,
  billId: ''
};

const PieceWageManager = () => {
  const clearPagi = useRef();
  const history = useHistory();
  const [data, setData] = useState([]);
  const [view, setView] = useState({
    edit: false,
    add: false,
    isDelete: false,
    isScan: false,

  });

  const methods = useForm({
    defaultValues: DEFAULT_PIECE_WAGE,
  });

  const {
    errors,
    register,
    handleSubmit,
    reset,
    getValues,
    control,
    setValue,
    watch
  } = methods;
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const [userOptions, setUserOptions] = useState([]);

  const [loading, setLoading] = useState(false);
  const [editId, setEditedId] = useState();
  const [deleteId, setDeleteId] = useState();
  const [timeNow, setTimeNow] = useState();
  const [smOption, setSmOption] = useState(false);
  const [filter, setFilter] = useState({
    customerId: searchParams.get('customerId') || undefined,
    categoryId: searchParams.get('categoryId') || undefined,
  });
  const [customerOptions, setCustomerOptions] = useState([]);
  const [pieceWageCategoryOptions, setPieceWageCategoryOptions] = useState([]);
  const [priceOptions, setPriceOptions] = useState([]);
  const [scanData, setScanData] = useState();
  const [rangeDate, setRangeDate] = useState({
    startDate: searchParams.get('startDate') ? moment(searchParams.get('startDate')).startOf('days').toDate() : moment().startOf('days').toDate(),
    endDate: searchParams.get('endDate') ? moment(searchParams.get('endDate')).endOf('days').toDate() : moment().endOf('days').toDate(),
  });

  const onRangeChange = (dates) => {
    const [startDate, endDate] = dates;
    setRangeDate({
      startDate: startDate ? moment(startDate)?.startOf('days').toDate() : startDate,
      endDate: endDate ? moment(endDate)?.endOf('days').toDate() : endDate
    });
    if (startDate && endDate) {
      setTimeNow(moment().valueOf());
    }
  };

  const colTable = [
    {
      Header: "Ngày",
      accessor: (item) => moment(item.date).format("DD/MM/YYYY"),
    },
    {
      Header: "Loại",
      accessor: (item) => item.pieceWageCategory?.name || '',
    },
    {
      Header: "Đơn Giá(đ)",
      className: 'text-right',
      accessor: (item) => <NumericFormat
        displayType={"text"}
        value={item.price || 0}
        thousandsGroupStyle="thousand"
        thousandSeparator=","
        decimalScale={2}
      />,
    },
    {
      Header: "Số lượng",
      className: 'text-right',
      accessor: (item) => <NumericFormat
        displayType={"text"}
        value={item.weight || 0}
        thousandsGroupStyle="thousand"
        thousandSeparator=","
        decimalScale={2}
      />,
    },
    {
      Header: "Giá tiền(đ)",
      className: 'text-right',
      accessor: (item) => <NumericFormat
        displayType={"text"}
        value={item.amount || 0}
        thousandsGroupStyle="thousand"
        thousandSeparator=","
        decimalScale={2}
      />,
    },
    {
      Header: "Nhân viên chưa x/nhận",
      accessor: (item) => <ul>{item?.user?.map(e => <li>{e.name}</li>)}</ul>,
    },
    {
      Header: "Nhân viên x/nhận",
      accessor: (item) => <ul>{item?.userAgreed?.map(e => <li>{e.name}</li>)}</ul>,
    },
    {
      Header: "Công Nhân viên(đ)",
      className: 'text-right',
      accessor: (item) => <NumericFormat
        displayType={"text"}
        value={item.salaryPerEmployee || 0}
        thousandsGroupStyle="thousand"
        thousandSeparator=","
        decimalScale={2}
      />,
    },
    {
      Header: "Trưởng ca",
      accessor: (item) => <ul>{item?.shiftLeader?.map(e => <li>{e.name}</li>)}</ul>,
    },
    {
      Header: "Công Trưởng ca(đ)",
      className: 'text-right',
      accessor: (item) => <NumericFormat
        displayType={"text"}
        value={item.salaryPerShiftLeader || 0}
        thousandsGroupStyle="thousand"
        thousandSeparator=","
        decimalScale={2}
      />,
    },
    {
      Header: "Tiền công ty(đ)",
      className: 'text-right',
      accessor: (item) => <NumericFormat
        displayType={"text"}
        value={item.salaryPerCompany || 0}
        thousandsGroupStyle="thousand"
        thousandSeparator=","
        decimalScale={2}
      />,
    },
    {
      Header: "Mã đơn",
      accessor: (item) => item.billId ? <Link to={`/bill/${item.billId}`}>{item.billId}</Link> : '',
    },
    {
      Header: "Xác nhận",
      accessor: (item) =>
        item?.user?.length === 0 ? (
          "Đã xác nhận"
        ) : (
          <Button
            className={"btn btn-primary"}
            onClick={() => {
              setScanData(item)
              toggle('isScan')
            }}
          >
            Hiện Scan
          </Button>
        ),
    },
    {
      Header: "Hành động",
      accessor: (item) => (
        <ul className="nk-tb-actions gx-1">
          <li>
            <UncontrolledDropdown>
              <DropdownToggle
                tag="a"
                className="btn btn-icon dropdown-toggle btn-trigger"
              >
                <Icon name="more-h"></Icon>
              </DropdownToggle>
              <DropdownMenu right>
                <ul className="link-list-opt no-bdr">
                  <li>
                    <DropdownItem
                      tag="a"
                      href="#dropdown"
                      onClick={(ev) => {
                        ev.preventDefault();
                        onEditClick(item.id);
                        toggle("edit");
                      }}
                    >
                      <Icon name="edit"></Icon>
                      <span>Sửa</span>
                    </DropdownItem>
                  </li>
                  <li>
                    <DropdownItem
                      tag="a"
                      href="#dropdown"
                      onClick={(ev) => {
                        ev.preventDefault();
                        setDeleteId(item.id);
                        toggle("isDelete");
                      }}
                    >
                      <Icon name="trash" className="text-danger"></Icon>
                      <span>Xoá</span>
                    </DropdownItem>
                  </li>
                </ul>
              </DropdownMenu>
            </UncontrolledDropdown>
          </li>
        </ul>
      ),
    },
  ];

  useEffect(() => {
    GET("user/list-user-can-piece-wage", {}, true).then((resp) => {
      setUserOptions(
        resp.data?.map((c) => ({
          label: c.name,
          value: c.id,
          data: c,
        }))
      );
    });

    GET("/customer", {}, true).then(({ data }) => {
      setCustomerOptions([
        ...data?.map((c) => ({
          label: c.name,
          value: c.id,
          data: c,
        })),
      ]);
    });

    GET("/employee/piece-wage-category", {}, true).then(({ data }) => {
      setPieceWageCategoryOptions([
        ...data?.map((c) => ({
          label: `${c.name}-${PIECE_WAGE_PRICE_TYPE[c.priceType]}`,
          value: c.id,
          data: c,
        })),
      ]);
    });


  }, []);

  // Changing state value when searching name
  useEffect(() => {

    const newParams = new URLSearchParams({
      ...rangeDate,
      ...(filter.customerId ? { customerId: filter.customerId } : {}),
      ...(filter.categoryId ? { categoryId: filter.categoryId } : {}),
    });
    history.replace({
      pathname: location.pathname,
      search: newParams.toString(),
    })

    setLoading(true);
    setData([]);
    clearTimeout(clearPagi.current);
    clearPagi.current = setTimeout(() => {
      let params = {
        startDate: moment(rangeDate.startDate).format("YYYY-MM-DD"),
        endDate: moment(rangeDate.endDate).format("YYYY-MM-DD"),
        ...(filter.customerId ? { customerId: filter.customerId } : {}),
        ...(filter.categoryId ? { categoryId: filter.categoryId } : {}),
      };

      GET(`employee/piece-wage`, params, true)
        .then(({ data }) => {
          setData([...data]);
        })
        .finally(() => {
          setLoading(false);
        });
    }, 400);
  }, [timeNow, filter]);

  // toggle function to view order details
  const toggle = (type) => {
    setView({
      ...view,
      [type]: !view[type],
    });
  };

  const categoryId = watch('categoryId');

  useEffect(() => {
    if (!categoryId) {
      return;
    }
    setPriceOptions([]);
    setValue('price', 0);

    const category = pieceWageCategoryOptions.find((data) => data.value === categoryId).data;
    if (category.priceType === 'STATIC' || category.priceType === 'PRICE_PER_UNIT') {
      setValue('price', category.price);
    }
    if (category.priceType === 'OPTIONS') {
      setPriceOptions((JSON.parse(category?.price) || '[]').map(e => ({
        value: e.value,
        label: e.description
      })));
    }
  }, [categoryId])
  const onEditClick = (id) => {
    setLoading(true);
    setEditedId(id);

    GET(`employee/piece-wage/${id}`, {}, true)
      .then(({ data }) => {
        reset({
          ...data,
        });
      })
      .catch(({ response }) => {
        toast.error(
          response?.data?.error || "Có lỗi xảy ra! Vui lòng thử lại."
        );
        onFormCancel();

      })
      .finally(() => {
        setLoading(false);
      });
  };

  const resetData = () => {
    setEditedId("");
    onFormCancel();
    setTimeNow(moment().valueOf());
  };

  const genScanQRData = (item) => {
    if (!item) {
      return '';
    }
    const data = JSON.stringify({
      action: ACTION_SCAN.PIECE_WAGE,
      data: {
        id: item.id
      }
    });

    return Buffer.from(data).toString("base64");;
  }

  // Submits form data
  const onHandleSubmit = () => {
    setLoading(true);
    const {
      date,
      customerId,
      userIds,
      shiftLeaderIds,
      categoryId,
      weight,
      price,
      billId,
    } = getValues();

    const formData = {
      date,
      customerId,
      shiftLeaderIds,
      userIds,
      categoryId,
      weight,
      price,
      billId,
    };

    const request = editId
      ? PUT(`employee/piece-wage/${editId}`, formData, {}, true)
      : POST("employee/piece-wage", formData, {}, true);

    request
      .then((res) => {
        if (editId) {
          toast.success("Cập nhật thành công");
        } else {
          toast.success("Thêm thành công");
        }
        resetData();
      })
      .catch(({ response }) => {
        toast.error(
          response?.data?.error || "Có lỗi xảy ra! Vui lòng thử lại."
        );
      })
      .finally(() => {
        setLoading(false);
      });
  };

  // function to close the form modal
  const onFormCancel = () => {
    setView({ add: false, edit: false, isDelete: false, isScan: false });
    reset(DEFAULT_PIECE_WAGE);
    setEditedId();
    setDeleteId();
    setScanData();
  };

  const deleteOrder = (id) => {
    if (!id) {
      return;
    }
    DELETE(`employee/piece-wage/${id}`, {}, true)
      .then((res) => {
        toast.success("Xóa thành công");
        resetData();
      })
      .catch(({ response }) => {
        toast.error(
          response?.data?.error || "Có lỗi xảy ra! Vui lòng thử lại."
        );
      });
  };

  return (
    <React.Fragment>
      <Head title="Quản lý Xuống hàng"></Head>
      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page>Xuống hàng</BlockTitle>
            </BlockHeadContent>
            <BlockHeadContent>
              <div className="toggle-wrap nk-block-tools-toggle">
                <a
                  href="#more"
                  className="btn btn-icon btn-trigger toggle-expand mr-n1"
                  onClick={(ev) => {
                    ev.preventDefault();
                    setSmOption(!smOption);
                  }}
                >
                  <Icon name="more-v"></Icon>
                </a>
                <div
                  className="toggle-expand-content"
                  style={{ display: smOption ? "block" : "none" }}
                >
                  <ul className="d-lg-flex g-3 pt-1 pb-1 custom-filter-header justify-content-end">
                    <li>
                      <div className="form-control-wrap">
                        <DatePicker
                          selected={rangeDate.startDate}
                          startDate={rangeDate.startDate}
                          onChange={onRangeChange}
                          endDate={rangeDate.endDate}
                          maxDate={new Date()}
                          selectsRange
                          className="form-control date-picker"
                        />
                      </div>
                    </li>
                    <li>
                      <div
                        className="form-control-wrap"
                        style={{ width: "200px" }}
                      >
                        <ReactSelect
                          isClearable
                          placeholder="Tìm kiếm danh mục"
                          classNamePrefix="form-control"
                          options={pieceWageCategoryOptions}
                          value={pieceWageCategoryOptions.find(
                            (c) => c.value === filter.categoryId
                          )}
                          onChange={(val) =>
                            setFilter({
                              ...filter,
                              categoryId: (val && val.value) || "",
                            })
                          }
                        />
                      </div>
                    </li>
                    <li>
                      <div
                        className="form-control-wrap"
                        style={{ width: "200px" }}
                      >
                        <ReactSelect
                          isClearable
                          placeholder="Tìm kiếm KH/NCC"
                          classNamePrefix="form-control"
                          options={customerOptions}
                          value={customerOptions.find(
                            (c) => c.value === filter.customerId
                          )}
                          onChange={(val) =>
                            setFilter({
                              ...filter,
                              customerId: (val && val.value) || "",
                            })
                          }
                        />
                      </div>
                    </li>

                    <li>
                      <div>
                        <Button
                          className="btn-primary"
                          color="primary"
                          onClick={() => {
                            onFormCancel();
                            toggle("add");
                          }}
                        >
                          <Icon name="plus"></Icon>
                          <span>Thêm xuống cấn</span>
                        </Button>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>

        <Block>
          <div className="card card-bordered card-preview">
            <div className="card-inner">
              <div
                id="DataTables_Table_1_wrapper"
                className="dataTables_wrapper dt-bootstrap4 no-footer"
              >
                <div className="row justify-between g-2">
                  <div className="col-8 col-sm-6 text-start"></div>
                  <div className="col-5 col-sm-6 text-end">
                    <div className="datatable-filter">
                      <div className="d-flex justify-content-end g-2">
                        <div
                          className="dataTables_length"
                          id="DataTables_Table_1_length"
                        ></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="my-3">
                  <Table
                    loading={loading}
                    columns={colTable}
                    data={data}
                    notShowPagi={true}
                  ></Table>
                </div>
              </div>
            </div>
          </div>
        </Block>
        <Modal
          isOpen={view.add || view.edit}
          toggle={() => onFormCancel()}
          className="modal-dialog-centered"
          size="lg"
        >
          <ModalBody>
            <a href="#cancel" className="close">
              {" "}
              <Icon
                name="cross-sm"
                onClick={(ev) => {
                  ev.preventDefault();
                  onFormCancel();
                }}
              ></Icon>
            </a>
            <div className="p-2">
              <h5 className="title">{editId ? "Sửa" : "Thêm"}</h5>
              <div className="mt-4">
                <FormProvider {...methods}>
                  <form onSubmit={handleSubmit(onHandleSubmit)}>
                    <Row className="g-3">
                      <Col md="12">
                        <div className="form-group">
                          <label className="form-label" htmlFor="customer">
                            Mã đơn
                          </label>
                          <div className="form-control-wrap">
                            <SearchBill />
                          </div>
                        </div>
                      </Col>
                      <Col md="12">
                        <div className="form-group">
                          <label className="form-label" htmlFor="customer">
                            Ngày
                            <span className="text-danger">*</span>
                          </label>
                          <div className="form-control-wrap">
                            <input
                              type="date"
                              className="form-control"
                              name="date"
                              ref={register({
                                required: "Vui lòng nhập thông tin",
                              })}
                            />
                            <ErrorMessage
                              errors={errors}
                              name="date"
                              render={({ message }) => (
                                <span className="invalid">{message}</span>
                              )}
                            />
                          </div>
                        </div>
                      </Col>





                      <Col md="12">
                        <div className="form-group">
                          <label className="form-label" htmlFor="customer">
                            Nhân viên
                            <span className="text-danger">*</span>
                          </label>
                          <div className="form-control-wrap">
                            <Controller
                              control={control}
                              name="userIds"
                              render={({ onChange, value, name, ref }) => (
                                <ReactSelect
                                  isMulti
                                  classNamePrefix="form-control"
                                  inputRef={ref}
                                  name={name}
                                  options={userOptions}
                                  value={userOptions.filter(
                                    (c) => {
                                      return value?.includes(c.value)
                                    }
                                  )}
                                  onChange={(val) => {
                                    onChange(val.map(e => e.value) || [])
                                  }}
                                />
                              )}
                            />
                            <ErrorMessage
                              errors={errors}
                              name="userIds"
                              render={({ message }) => (
                                <span className="invalid">{message}</span>
                              )}
                            />
                          </div>
                        </div>
                      </Col>
                      <Col md="12">
                        <div className="form-group">
                          <label className="form-label" htmlFor="customer">
                            Trưởng ca
                          </label>
                          <div className="form-control-wrap">
                            <Controller
                              control={control}
                              name="shiftLeaderIds"
                              render={({ onChange, value, name, ref }) => (
                                <ReactSelect
                                  isMulti
                                  classNamePrefix="form-control"
                                  inputRef={ref}
                                  name={name}
                                  options={userOptions.filter(user => user.data.role === 'SHIFT_LEADER')}
                                  value={userOptions.filter(
                                    (c) => {
                                      return value?.includes(c.value)
                                    }
                                  )}
                                  onChange={(val) => {
                                    onChange(val.map(e => e.value) || [])
                                  }}
                                />
                              )}
                            />
                            <ErrorMessage
                              errors={errors}
                              name="shiftLeaderIds"
                              render={({ message }) => (
                                <span className="invalid">{message}</span>
                              )}
                            />
                          </div>
                        </div>
                      </Col>


                      <Col md="12">
                        <div className="form-group">
                          <label className="form-label" htmlFor="customer">
                            Danh mục
                            <span className="text-danger">*</span>
                          </label>
                          <div className="form-control-wrap">
                            <Controller
                              control={control}
                              name="categoryId"
                              rules={{ required: "Vui lòng nhập thông tin" }}
                              render={({ onChange, value, name, ref }) => (
                                <ReactSelect
                                  classNamePrefix="form-control"
                                  inputRef={ref}
                                  name={name}
                                  options={pieceWageCategoryOptions}
                                  value={pieceWageCategoryOptions.find(
                                    (c) => c.value === value
                                  )}
                                  onChange={(val) => onChange(val.value)}
                                />
                              )}
                            />
                            <ErrorMessage
                              errors={errors}
                              name="categoryId"
                              render={({ message }) => (
                                <span className="invalid">{message}</span>
                              )}
                            />
                          </div>
                        </div>
                        {priceOptions.length > 0 ? <div className="form-group">

                          <RSelect
                            options={priceOptions}
                            onChange={({ value }) => {
                              setValue('price', value)
                            }}
                          />

                        </div>
                          : <></>}
                      </Col>

                      <Col md="12">
                        <div className="form-group">
                          <label className="form-label" htmlFor="customer">
                            Đơn giá
                            <span className="text-danger">*</span>
                          </label>
                          <div className="form-control-wrap">
                            <Controller
                              control={control}
                              name="price"
                              rules={{ required: "Vui lòng nhập thông tin" }}
                              render={({ onChange, value, ref }) => (
                                <NumericFormat
                                  className="form-control"
                                  inputRef={ref}
                                  type="text"
                                  value={value}
                                  thousandsGroupStyle="thousand"
                                  thousandSeparator=","
                                  decimalScale={2}
                                  onValueChange={(val) =>
                                    onChange(val.floatValue)
                                  }
                                />
                              )}
                            />
                            <ErrorMessage
                              errors={errors}
                              name="price"
                              render={({ message }) => (
                                <span className="invalid">{message}</span>
                              )}
                            />
                          </div>
                        </div>
                      </Col>
                      <Col md="12">
                        <div className="form-group">
                          <label className="form-label" htmlFor="customer">
                            Số lượng
                            <span className="text-danger">*</span>
                          </label>
                          <div className="form-control-wrap">
                            <Controller
                              control={control}
                              name="weight"
                              rules={{ required: "Vui lòng nhập thông tin" }}
                              render={({ onChange, value, ref }) => (
                                <NumericFormat
                                  className="form-control"
                                  inputRef={ref}
                                  type="text"
                                  value={value}
                                  thousandsGroupStyle="thousand"
                                  thousandSeparator=","
                                  decimalScale={2}
                                  onValueChange={(val) =>
                                    onChange(val.floatValue)
                                  }
                                />
                              )}
                            />
                            <ErrorMessage
                              errors={errors}
                              name="weight"
                              render={({ message }) => (
                                <span className="invalid">{message}</span>
                              )}
                            />
                          </div>
                        </div>
                      </Col>

                      <Col size="12">
                        <Button color="primary" type="submit">
                          <span>{editId ? "Sửa" : "Thêm"}</span>
                        </Button>
                      </Col>
                    </Row>
                  </form>
                </FormProvider>
              </div>
            </div>
          </ModalBody>
        </Modal>


        <Modal isOpen={view.isDelete} toggle={() => onFormCancel()}>
          <ModalBody className="modal-body-lg text-center">
            <div className="nk-modal">
              <Icon className="nk-modal-icon icon-circle icon-circle-xxl ni ni-cross bg-danger"></Icon>
              <h4 className="nk-modal-title">
                Bạn có chắc muốn xoá giao dịch này không ?{" "}
              </h4>
              <div className="nk-modal-action mt-5 d-flex justify-content-around">
                <Button
                  color="light"
                  size="lg"
                  className="btn-mw mr-5"
                  onClick={() => onFormCancel()}
                >
                  Huỷ bỏ
                </Button>
                <Button
                  color="primary"
                  size="lg"
                  className="btn-mw"
                  onClick={(ev) => {
                    ev.preventDefault();
                    deleteOrder(deleteId);
                  }}
                >
                  Xác nhận
                </Button>
              </div>
            </div>
          </ModalBody>
        </Modal>

        <Modal isOpen={view.isScan} toggle={() => onFormCancel()}>
          <ModalBody className="modal-body-lg">
            <div className="nk-modal">
              <div className="d-flex flex-column align-center mt-3">
                <QRCode size={150} value={genScanQRData(scanData)} />
                <Button
                  className={'mt-2'}
                  color="light"
                  size="lg"
                  onClick={() => onFormCancel()}
                >
                  Đóng
                </Button>
              </div>

            </div>
          </ModalBody>
        </Modal>
      </Content>
    </React.Fragment>
  );
};

export default PieceWageManager;
